import { useMutation } from 'react-query';

import useApiHelper from '../../hooks/useApiHelper';
import { ChatRequest, ChatResponse } from '../../types/Orbit/Chat';
import {
  IDefaultResponseWithData,
} from './../../types/system/DefaultResponse';

export default function useOrbitChatMutation() {
  const { post } = useApiHelper();

  const sendMessage = useMutation((request: ChatRequest) =>
    post<ChatRequest, IDefaultResponseWithData<ChatResponse>>(
      '/v1/chat',
      request
    ).then((res) => res.data.data)
  );

  return {
    sendMessage,
  };
}
